'use client';

import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface VoiceWaveformProps {
  levels: number[];
  isActive: boolean;
  className?: string;
  barClassName?: string;
  minScale?: number;
}

export function VoiceWaveform({
  levels,
  isActive,
  className,
  barClassName,
  minScale = 0.25,
}: VoiceWaveformProps) {
  return (
    <div className={cn('flex h-14 w-full items-end gap-1', className)}>
      {levels.map((level, index) => (
        <motion.span
          key={index}
          className={cn('h-full flex-1 rounded bg-primary/80', barClassName)}
          style={{ transformOrigin: 'bottom' }}
          animate={{ scaleY: isActive ? Math.max(minScale, level) : minScale }}
          transition={{ type: 'spring', stiffness: 160, damping: 18 }}
        />
      ))}
    </div>
  );
}
